import React from 'react'
import { MainResetPassword } from '../../layouts/MainResetPassword/MainResetPassword'

export const ResetPassword = () => {
  return (
    <MainResetPassword />
  )
}
